<mat-dialog-content class="mat-typography">
      <div id="support_number" class="p-[1rem] flex flex-col items-center ">
          <h1 class="text-3xl mb-10">¿Cómo saber mi número de soporte?</h1>
          
          <div class=" section-document max-w-3xl card p-6 mb-6">
              <h2>Tarjeta de extranjero</h2>
              <div class="flex flex-col md:flex-row ">
                  <div class="img-wrapper w-full md:w-2/3">
                      <img [src]="'img/illustrations/extranjeros.png' | assetUrl" alt="Tarjeta de extranjero">
                  </div>
                  <div class="text p-1 w-full md:w-1/3">
                      9 caracteres: una letra E seguida de 8 
                      caracteres numéricos.  
                      En el caso de que el número de soporte 
                      que figura en su tarjeta tenga menos de 8 
                      caracteres numéricos, ha de introducir 
                      tantos ceros como caracteres numéricos 
                      falten a continuación de la letra E.
                  </div>
              </div>
          </div>

          <div class=" section-document max-w-3xl card p-6 mb-6">
              <h2>Permiso de residencia</h2>
              <div class="flex flex-col md:flex-row ">
                  <div class="img-wrapper w-full md:w-2/3">
                      <img [src]="'img/illustrations/residencia.png' | assetUrl" alt="Permiso de residencia">
                  </div>
                  <div class="text p-1 w-full md:w-1/3">
                      9 caracteres: una letra E seguida de 8 
                      caracteres numéricos.  
                      En el caso de que el número de soporte 
                      que figura en su tarjeta tenga menos de 8 
                      caracteres numéricos, ha de introducir 
                      tantos ceros como caracteres numéricos 
                      falten a continuación de la letra E.
                  </div>
              </div>
          </div>

          <div class=" section-document max-w-3xl card p-6 mb-6">
              <h2>Certificado Ciudadano UE</h2>
              <div class="flex flex-col md:flex-row ">
                  <div class="img-wrapper w-full md:w-2/3 ">
                      <img [src]="'img/illustrations/ciudadano.png' | assetUrl" alt="Certificado Ciudadano UE">
                      <img [src]="'img/illustrations/ciudadano2.png' | assetUrl" alt="Certificado Ciudadano UE">
                  </div>
                  <div class="text p-1 w-full md:w-1/3">
                    El número de soporte a introducir ha de tener una longitud de 9 posiciones: una letra C seguida de 8 caracteres numéricos. En el caso de que el número de soporte que figura en tu certificado tenga menos de 8 caracteres numéricos, hay que introducir tantos ceros como caracteres numéricos falten a continuación de la letra C.
                  </div>
              </div>
          </div>
      </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button      
    [style.color]="funderStyles.colors.btnText"
    [style.background]="funderStyles.colors.btnBg"
    [style.border-radius]="funderStyles.btnRound + 'px'"
    class="px-8" 
    mat-flat-button type="button" [mat-dialog-close]="true" cdkFocusInitial>Aceptar</button>
</mat-dialog-actions>